import TemplateView from '../../TemplateView'

export default class CommentsNumberCounter extends TemplateView {
    constructor({
        onClick = () => {}
    } = {}) {
        super()

        this.params = {
            onClick,
        }

        this.state = {
            commentsNumber: 0,
        }

        this.onStatePropertyChanged('commentsNumber', (number) => {
            this.$label.text(number)
        })
    }

    templateHtml() {
        return "<div class='components_commentsNumberCounter'>" +
               "  <span class='number label'></span>" +
               "  <span class='icon'></span>" +
               "</div>"
    }

    afterRender() {
        this.$label = this.find('.number.label')

        this.bindClick(() => {
            this.params.onClick()
        })

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/components/CommentsNumberCounter.js